import { useTranslation } from 'react-i18next'

import { Button } from '../../common/Button'
import { SvgIcon } from '../../common/SvgIcon'

type IProps = {
  onClick: () => void
}

export function AcceptInvitationButton({ onClick }: IProps) {
  const { t } = useTranslation()
  return (
    <Button onClick={() => onClick()}>
      <SvgIcon icon="okIcon" />
      {t('team.invitation.accept')}
    </Button>
  )
}
